import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://www.ordell.ro/webcare";

export function usePageMeta(title, description) {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = title;

    // Meta description
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;

    // Canonical
    const canonicalUrl = `${BASE_URL}${pathname === "/" ? "" : pathname}`;
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;

    // Hreflang ro
    let hreflang = document.querySelector('link[hreflang="ro"]');
    if (!hreflang) {
      hreflang = document.createElement("link");
      hreflang.rel = "alternate";
      hreflang.hreflang = "ro";
      document.head.appendChild(hreflang);
    }
    hreflang.href = canonicalUrl;

    // x-default
    let xdefault = document.querySelector('link[hreflang="x-default"]');
    if (!xdefault) {
      xdefault = document.createElement("link");
      xdefault.rel = "alternate";
      xdefault.hreflang = "x-default";
      document.head.appendChild(xdefault);
    }
    xdefault.href = canonicalUrl;
  }, [title, description, pathname]);
}
